const BASE_URL = 'https://mongobyte-hc73.onrender.com/api/v1';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

export const friendPaymentApi = {
  // Create order with friend payment
  createOrderWithFriendPayment: async (orderData, friendUsername, message) => {
    try {
      const response = await fetch(`${BASE_URL}/orders`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({
          ...orderData,
          paymentMethod: 'friend_payment',
          friendPayment: {
            friendUsername: friendUsername,
            message: message
          }
        })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Friend payment API error:', error);
      throw error;
    }
  },

  // Create payment request
  createPaymentRequest: async (orderId, friendUsername, message) => {
    try {
      const response = await fetch(`${BASE_URL}/payment-requests`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({
          orderId: orderId,
          payerUsername: friendUsername,
          message: message
        })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Payment request API error:', error);
      throw error;
    }
  },

  // Get payment requests
  getPaymentRequests: async (type = 'all', status = null, page = 1, limit = 10) => {
    try {
      let url = `${BASE_URL}/payment-requests?type=${type}&page=${page}&limit=${limit}`;
      // if (status) url += `&status=${status}`;
      
      const response = await fetch(url, {
        headers: getAuthHeaders()
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Get payment requests API error:', error);
      throw error;
    }
  },

  // Accept payment request
  acceptPaymentRequest: async (requestId, paymentMethod = 'wallet') => {
    try {
      const response = await fetch(`${BASE_URL}/payment-requests/${requestId}/accept`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({
          paymentMethod: paymentMethod
        })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Accept payment request API error:', error);
      throw error;
    }
  },

  // Decline payment request
  declinePaymentRequest: async (requestId, reason = '') => {
    try {
      const response = await fetch(`${BASE_URL}/payment-requests/${requestId}/decline`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({
          reason: reason
        })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Decline payment request API error:', error);
      throw error;
    }
  },

  // Cancel payment request
  cancelPaymentRequest: async (requestId) => {
    try {
      const response = await fetch(`${BASE_URL}/payment-requests/${requestId}`, {
        method: 'DELETE',
        headers: getAuthHeaders()
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Cancel payment request API error:', error);
      throw error;
    }
  }
};